import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function RefreshLineIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size}
            className='icon'
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <g transform="translate(4 2)">
                <path d="M10.8 4.72424C10.8 4.72424 11.8658 4.19924 8 4.19924C6.61553 4.19924 5.26216 4.60978 4.11101 5.37895C2.95987 6.14812 2.06266 7.24137 1.53285 8.52045C1.00303 9.79953 0.86441 11.207 1.13451 12.5649C1.4046 13.9227 2.07129 15.17 3.05026 16.149C4.02922 17.1279 5.2765 17.7946 6.63437 18.0647C7.99224 18.3348 9.3997 18.1962 10.6788 17.6664C11.9579 17.1366 13.0511 16.2394 13.8203 15.0882C14.5895 13.9371 15 12.5837 15 11.1992"
                    stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
                <path d="M8 1.00002L11 4.50002L8 8.00002"
                    stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>
    );
}

export default RefreshLineIcon;
